<template>
  <section class="question-guide-container">
    <div id="question-guide-id">
      <div class="q-cover">
        <img :src="qdata.front_img" @load="calcMainSize(true)" alt />
      </div>
      <h3 class="q-title">{{ qdata.title }}</h3>
      <p class="q-desc">{{ qdata.explain }}</p>
    </div>
    <div :class="{ 'sticker-botom': isShowSticker }">
      <div class="go-answer" @click="begin">立即答题</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MultiIndex',
  data() {
    return {
      isShowSticker: false, // 按钮是否吸底
    };
  },
  props: {
    qdata: {
      type: Object,
      default: () => {},
    },
    begin: {
      type: Function,
      required: true,
    },
  },
  methods: {
    // 计算主体尺寸，确定按钮是否吸底
    calcMainSize(isLoad = false) {
      // 如果有封面图，登封面图加载完成
      if (this.qdata.front_img && !isLoad) return;
      const main = document.querySelector('#question-guide-id');
      const mainH = main.offsetHeight;
      const bodyH = document.body.offsetHeight;
      if (mainH - bodyH > 80) {
        this.isShowSticker = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.question-guide-container {
  padding: 0 16px;
  padding-bottom: 44px;
  .q-cover {
    font-size: 0;
    padding: 20px 0;
    img {
      width: 100%;
      border-radius: 5px;
    }
  }
  .q-title {
    font-size: 20px;
    color: #000;
    font-weight: 500;
  }
  .q-desc {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.64);
    margin-bottom: 40px;
    word-break: break-all;
  }
  .go-answer {
    height: 44px;
    border-radius: 8px;
    line-height: 44px;
    background-color: #ff6600;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
  .sticker-botom {
    position: fixed;
    left: 16px;
    right: 16px;
    bottom: 0px;
    height: 60px;
    background-color: #fff;
  }
}
</style>
